
<div>
  <div>{{ selectedAttachmentType }}</div>
  <slot></slot>
</div>
